<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Assistance appel vocal</div>
</div>

@if (step == 1) {
    <div class="col-12 w-100 text-center">
        Avez-vous éteint et rallumé votre téléphone?
        <br/><br/>
        <div class="cta_container">
            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            <button type="button" class="cta_btn level_2 column" (click)="setStep(2)">Valider<span></span></button>
        </div>
    </div>
}

@if (step == 2) {
    <div class="row w-100 pt-3">
        <div class="row w-100 pb-2 ml-2">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="errorMessage" [(ngModel)]="displayedMessage">
                <label class="custom-control-label bold-label" for="errorMessage">Y-a-t il un message d'erreur affiché sur votre mobile ?</label>
            </div>
            @if (displayedMessage == 1) {
                <div class="row w-100 ml-3">
                    <select name="label" class="custom-select w-auto" [(ngModel)]="displayedMessageValue">
                        @for (errorMessage of constsHelper.PROCEDURE_VOICE_CALL_ASSISTANCE_ERROR_MESSAGES; track errorMessage) {
                            <option value="{{ errorMessage.value }}">{{ errorMessage.label }}</option>
                        }
                    </select>
                </div>
            }
        </div>
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left">Nombre de barrette(s) réseau affichée(s)</span>
            <input type="number" min="0" class="form-control" [(ngModel)]="networkBarsNumber">
            @if (errorNetworkBarsNumber) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
        </div>
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left">Nom de l'opérateur affiché</span>
            <input type="text" class="form-control" [(ngModel)]="operatorName">
            @if (errorOperatorName) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
        </div>
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left w-100">Apparition du problème</span>
            <div class="col-auto ml-1">
                <input type="radio" class="form-check-input" name="appearanceProblem" [(ngModel)]="appearanceProblem" value="Dégradation"/>
                <label class="form-check-label">Dégradation</label>
            </div>
            <div class="col-auto">
                <input type="radio" class="form-check-input" name="appearanceProblem" [(ngModel)]="appearanceProblem" value="N'a jamais fonctionné" checked/>
                <label class="form-check-label">N'a jamais fonctionné</label>
            </div>
        </div>
        <div class="row w-100 pb-2 ml-2">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="audioProblem" [(ngModel)]="audioProblem" (change)="resetAudioProblems()">
                <label class="custom-control-label bold-label" for="audioProblem">Avez-vous des problèmes de qualité audio ?</label>
            </div>
            @if (audioProblem == 1) {
                <div class="row w-100 ml-4">
                    <div class="custom-control custom-checkbox row w-100">
                        <input type="checkbox" class="custom-control-input" name="audioProblemValue" value="Coupure des communications" (change)="saveAudioProblems($event)" id="disconnectionCommunication"/>
                        <label class="custom-control-label" for="disconnectionCommunication">Coupure des communications</label>
                    </div>
                    <div class="custom-control custom-checkbox row w-100">
                        <input type="checkbox" class="custom-control-input" name="audioProblemValue" value="Communications dégradées" (change)="saveAudioProblems($event)" id="degradedCommunication"/>
                        <label class="custom-control-label" for="degradedCommunication">Communications dégradées</label>
                    </div>
                    <div class="custom-control custom-checkbox row w-100">
                        <input type="checkbox" class="custom-control-input" name="audioProblemValue" value="Dès le début de la communication" (change)="saveAudioProblems($event)" id="fromBeginningCommunication"/>
                        <label class="custom-control-label" for="fromBeginningCommunication">Dès le début de la communication</label>
                    </div>
                    @if (errorAudioProblem) {
                        <p class="error-message w-100">Ce champ est invalide</p>
                    }
                </div>
            }
        </div>
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left w-100">De quel type est le problème rencontré ?</span>
            <div class="col-auto ml-1">
                <input type="radio" class="form-check-input" name="problemType" [(ngModel)]="problemType" value="Emission d'appels"/>
                <label class="form-check-label">Emission d'appels</label>
            </div>
            <div class="col-auto">
                <input type="radio" class="form-check-input" name="problemType" [(ngModel)]="problemType" value="Réception d'appels"/>
                <label class="form-check-label">Réception d'appels</label>
            </div>
            <div class="col-auto">
                <input type="radio" class="form-check-input" name="problemType" [(ngModel)]="problemType" value="Emission et réception d'appels"/>
                <label class="form-check-label">Emission et réception d'appels</label>
            </div>
            @if (problemType == 'Emission et réception d\'appels') {
                <div class="row w-100 ml-2">
                    <span class="bold-label-text float-left">Autre numéro où nous pouvons vous contacter</span>
                    <input type="text" class="form-control" [(ngModel)]="problemTypeContact">
                    @if (errorProblemTypeContact) {
                        <p class="error-message w-100">Ce champ est invalide</p>
                    }
                </div>
            }
        </div>
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left w-100">Vers / Depuis quelle destination le problème survient-il ?</span>
            <div class="col-auto ml-1">
                <input type="radio" class="form-check-input" name="problemDestination" [(ngModel)]="problemDestination" value="En France"/>
                <label class="form-check-label">En France</label>
            </div>
            @if (problemType == 'Emission d\'appels') {
                <div class="col-auto">
                    <input type="radio" class="form-check-input" name="problemDestination" [(ngModel)]="problemDestination" value="Vers l'étranger"/>
                    <label class="form-check-label">Vers l'étranger</label>
                </div>
            }
            <div class="col-auto">
                <input type="radio" class="form-check-input" name="problemDestination" [(ngModel)]="problemDestination" value="Depuis l'étranger"/>
                <label class="form-check-label">Depuis l'étranger</label>
            </div>
        </div>
        <div class="row w-100 pb-2 ml-2">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="oldOperatorPhonePurchased" [(ngModel)]="oldOperatorPhonePurchased">
                <label class="custom-control-label bold-label" for="oldOperatorPhonePurchased">Le téléphone a-t-il été acheté auprès d'un ancien opérateur ?</label>
            </div>
            @if (oldOperatorPhonePurchased == 1) {
                <div class="row w-100 ml-2">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="unlockedPhone" [(ngModel)]="unlockedPhone">
                        <label class="custom-control-label" for="unlockedPhone">Avez-vous débloqué votre téléphone auprès de cet opérateur?</label>
                    </div>
                </div>
            }
        </div>
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left w-100">Saisissez les informations de votre téléphone. L'imei s'obtient en composant le *#06#</span>IMEI : <input type="number" min="0" class="form-control" [(ngModel)]="imeiPhone">
            @if (errorImeiPhone) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
            Marque : <input type="text" class="form-control" [(ngModel)]="brandPhone">
            @if (errorBrandPhone) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
            Modèle : <input type="text" class="form-control" [(ngModel)]="modelPhone">
            @if (errorModelPhone) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
        </div>
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left w-100">Test croisé : merci de placer votre carte SIM dans un autre téléphone. Ce test nous permettra de déterminer si votre carte SIM est à l'origine du problème.</span>
            Date du test : <input type="date" class="form-control" [(ngModel)]="crossTestDate" min="{{minDate}}"
                                  max="{{maxDate}}">
            @if (errorCrossTestDate) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
            Marque du téléphone utilisé : <input type="text" class="form-control" [(ngModel)]="crossTestBrandPhone">
            @if (errorCrossTestBrandPhone) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
            Modèle du téléphone utilisé : <input type="text" class="form-control" [(ngModel)]="crossTestModelPhone">
            @if (errorCrossTestModelPhone) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
            Le test a t-il corrigé l'anomalie ?
            <div class="col-auto ml-2">
                <input type="radio" class="form-check-input" name="crossTestResult" [(ngModel)]="crossTestResult" value="1"/>
                <label class="form-check-label">Oui</label>
            </div>
            <div class="col-auto">
                <input type="radio" class="form-check-input" name="crossTestResult" [(ngModel)]="crossTestResult" value="0"/>
                <label class="form-check-label">Non</label>
            </div>
        </div>
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left w-100">Fréquence d'apparition du problème</span>
            <div class="col-auto ml-1">
                <input type="radio" class="form-check-input" name="occurrenceFrequencyProblem" [(ngModel)]="occurrenceFrequencyProblem" value="Permanent"/>
                <label class="form-check-label">Permanent</label>
            </div>
            <div class="col-auto">
                <input type="radio" class="form-check-input" name="occurrenceFrequencyProblem" [(ngModel)]="occurrenceFrequencyProblem" value="Aléatoire"/>
                <label class="form-check-label">Aléatoire</label>
            </div>
        </div>
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left w-100">Type d'utilisation</span>
            <div class="col-auto ml-1">
                <input type="radio" class="form-check-input" name="usageType" [(ngModel)]="usageType" value="Extérieur"/>
                <label class="form-check-label">Extérieur</label>
            </div>
            <div class="col-auto">
                <input type="radio" class="form-check-input" name="usageType" [(ngModel)]="usageType" value="Intérieur"/>
                <label class="form-check-label">Intérieur</label>
            </div>
        </div>
        <div class="row w-100 pb-2 ml-2">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="operatorProblem" [(ngModel)]="operatorProblem">
                <label class="custom-control-label bold-label" for="operatorProblem">Le problème survient-il vers / depuis un opérateur en particulier ?</label>
            </div>
            @if (operatorProblem == 1) {
                <div class="row w-100 ml-3">
                    Lequel ? <input type="text" class="form-control" [(ngModel)]="operatorProblemValue">
                    @if (errorOperatorProblemValue) {
                        <p class="error-message w-100">Ce champ est invalide</p>
                    }
                </div>
            }
        </div>
        <div class="row w-100 pb-2 ml-2">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="correspondentProblem" [(ngModel)]="correspondentProblem">
                <label class="custom-control-label bold-label" for="correspondentProblem">Le problème survient-il vers / depuis un correspondant en particulier ?</label>
            </div>
            @if (correspondentProblem == 1) {
                <div class="row w-100 ml-3">
                    Lequel ? <input type="text" class="form-control" [(ngModel)]="correspondentProblemValue">
                    @if (errorCorrespondentProblemValue) {
                        <p class="error-message w-100">Ce champ est invalide</p>
                    }
                </div>
            }
        </div>
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left w-100">Information sur l'incident</span>
            <div class="col-auto ml-1">
                <input type="radio" class="form-check-input" name="incidentInformation" [(ngModel)]="incidentInformation" value="Localisé"/>
                <label class="form-check-label">Localisé</label>
            </div>
            <div class="col-auto">
                <input type="radio" class="form-check-input" name="incidentInformation" [(ngModel)]="incidentInformation" value="Ne dépend pas d'une localisation particulière"/>
                <label class="form-check-label">Ne dépend pas d'une localisation particulière</label>
            </div>
        </div>
        @if (incidentInformation == 'Localisé') {
            <div class="row w-100 pb-2 ml-2">
                <span class="bold-label-text float-left w-100">Ampleur de l'incident</span>
                <div class="col-auto ml-1">
                    <input type="radio" class="form-check-input" name="incidentMagnitude" [(ngModel)]="incidentMagnitude" value="Une adresse"/>
                    <label class="form-check-label">Une adresse</label>
                </div>
                <div class="col-auto">
                    <input type="radio" class="form-check-input" name="incidentMagnitude" [(ngModel)]="incidentMagnitude" value="Une rue"/>
                    <label class="form-check-label">Une rue</label>
                </div>
                <div class="col-auto">
                    <input type="radio" class="form-check-input" name="incidentMagnitude" [(ngModel)]="incidentMagnitude" value="Un quartier"/>
                    <label class="form-check-label">Un quartier</label>
                </div>
                <div class="col-auto">
                    <input type="radio" class="form-check-input" name="incidentMagnitude" [(ngModel)]="incidentMagnitude" value="Un pays"/>
                    <label class="form-check-label">Un pays</label>
                </div>
            </div>
        }
        @if (incidentMagnitude == 'Un pays') {
            <div class="row w-100 pb-2 ml-2">
                <span class="bold-label-text float-left w-100">Quel pays ?</span>
                <div class="row w-100">
                    <select name="country" class="custom-select w-auto ml-3" [(ngModel)]="incidentMagnitudeCountry">
                        @for (country of countries; track country) {
                            <option value="{{ country.name }}">{{ country.name }}</option>
                        }
                    </select>
                </div>
            </div>
        }
        <div class="row w-100 pb-2 ml-2">
            <span class="bold-label-text float-left w-100">Dernier appel concerné par votre problème (datant de moins de 4 jours)</span>
            Correspondant : <input type="text" class="form-control" [(ngModel)]="lastCallProblemCorrespondent">
            @if (errorLastCallProblemCorrespondent) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
            Opérateur du correspondant : <input type="text" class="form-control" [(ngModel)]="lastCallProblemOperator">
            @if (errorLastCallProblemOperator) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
            Date et heure : <input type="datetime-local" class="form-control" [(ngModel)]="lastCallProblemDate" min="{{minDate+'T00:00'}}" max="{{maxDate+'T00:00'}}">
            @if (errorLastCallProblemDate) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
            Adresse de votre incident : <input type="text" class="form-control" [(ngModel)]="lastCallProblemAddress">
            @if (errorLastCallProblemAddress) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
            Code postal : <input type="text" class="form-control" [(ngModel)]="lastCallProblemZipCode">
            @if (errorLastCallProblemZipCode) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
            Ville : <input type="text" class="form-control" [(ngModel)]="lastCallProblemCity">
            @if (errorLastCallProblemCity) {
                <p class="error-message w-100">Ce champ est invalide</p>
            }
        </div>
        <div class="col-12 w-100 text-center cta_container">
            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
        </div>
    </div>
}
